import { GoogleSaveServiceAccountCredsForm } from "@/Features";
import { styled } from "@monolith-forensics/monolith-ui";
import { useNavigate } from "react-router-dom";

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const Description = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const GoogleServiceAccountCredentialsPage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Title>Enter Google Service Account Credentials</Title>
      <GoogleSaveServiceAccountCredsForm
        onCancel={() => navigate("/settings/integrations/google")}
        onSaved={() => navigate("/settings/integrations/google")}
      />
    </div>
  );
};
